import { CircularProgress, Grid, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { Documents } from '@assets/index';
import { useFetch } from '@hooks/useFetch';
import { SystemUrl, fetchSystemData } from '@api/system';
import { useSelector } from 'react-redux';
import { GenericTable } from '@components/GenericTable';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@consts/routes';
import { SystemModelMap } from '@consts/systems';

import type { System } from '@api/system';
import type { RootState } from '@features/redux/store';
import { isAdmin } from '@utils/permissions';
import { useStyles } from './styles/LocationSystems.styles';

interface LocationSystemsProps {
    locationId: number | undefined;
}

export const LocationSystems = ({ locationId }: LocationSystemsProps) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const navigate = useNavigate();
    const classes = useStyles();

    // todo: Use RTKQuery
    const { data, loading } = useFetch({
        spinner: false,
        defaultValue: [],
        fetcher: async () => {
            return locationId
                ? fetchSystemData<System[]>(IdToken!, SystemUrl.StationsByLocation, {
                      locationId,
                      type: 'assigned',
                  })
                : [];
        },
    });

    const admin = isAdmin(IdToken!);

    const headers = [
        { label: 'Model', width: 100 },
        { label: 'Serial Number', width: 100 },
        { label: 'Status', width: 100 },
    ];

    const adminHeaders = [{ label: 'Station ID', width: 100 }];

    const allHeaders = admin ? [...headers, ...adminHeaders] : headers;

    return (
        <Grid container spacing={2} marginTop='10px' padding={'20px'}>
            <Grid item xs={12} sm={12} md={12}>
                <Typography fontWeight='bold'>RapidCut System Information:</Typography>
            </Grid>
            {loading ? (
                <Grid item xs={12} sm={12} md={12} className={classes.messageContainer}>
                    <CircularProgress size='3rem' />
                </Grid>
            ) : data.length === 0 ? (
                <Grid item xs={12} sm={12} md={12} className={classes.messageContainer}>
                    <Documents />
                    <Typography fontWeight='bold'>There are no RapidCut systems assigned to this location.</Typography>
                </Grid>
            ) : (
                <GenericTable maxHeight={300} headers={allHeaders}>
                    {data.map((system) => (
                        <Tooltip key={system.StationID} title={'Click to manage'} placement='top'>
                            <TableRow
                                className={classes.row}
                                onClick={() => navigate(`${AppRoutes.ManageSystem}?id=${system.StationID}`)}>
                                <TableCell style={{ padding: '10px' }}>
                                    {SystemModelMap[system.Model?.toString() as string] || 'Unknown Model'}
                                </TableCell>
                                <TableCell style={{ padding: '10px' }}>{system.SerialNum || '-'}</TableCell>
                                <TableCell style={{ padding: '10px' }}>{system.Status || '-'}</TableCell>
                                {admin && <TableCell style={{ padding: '10px' }}>{system.StationID}</TableCell>}
                            </TableRow>
                        </Tooltip>
                    ))}
                </GenericTable>
            )}
        </Grid>
    );
};
